  <template>
  <div class="economy">
    <el-container>
      <el-header>
        <div style="position: relative;">
          <Head
            :active="5"
            :isBanner="true"
            :color="'black'"
            indicator="none"
          >
          </Head>
          <img
            class="bans"
            src="../../public/img/economy/btn.png"
            alt=""
            @click="btnclk"
          />
        </div>
        <dkjjimg 
          :bannerData="bannerData"
          :isBanner="true"
          :color="'black'"
          indicator="none" />
      </el-header>
      <div>
        <plan-dialog
          :isShow="isShow"
          v-if="isShow"
          @closeTop="closeTop"
        ></plan-dialog>
      </div>
      <!-- <div class="whiteup"></div> -->
      <div class="whiteTop">
        <img src="@img/economy/bg_dkjj_white_a.png" alt="" />
      </div>
      <el-main>
        <div class="summing">
          <div class="left">
            <div class="title">
              <img
                class="titleimg"
                src="@img/economy/pic_dkjj_title_zqgj.png"
                alt=""
              />
            </div>
            <div class="desc">
              <p>
                通过AI技术深度赋能，构建了"智能感知-决策分析-协同执行"的闭环治理体系。政府与企业联合搭建AI驱动的无人机管理平台，整合5G通信、边缘计算与多模态算法，形成覆盖城市治理、应急响应、产业服务的立体化应用网络。AI算法为核心引擎，实现无人机自主飞行规划、实时图像识别与数据智能分析，提升任务效率与精准度。
              </p>
              <p style="margin-top: 16px">
                通过AI技术的深度集成，无人机政企共建场景正从单一工具应用升级为系统性治理方案，以智能化手段破解传统治理中的覆盖盲区与响应滞后难题，为新型智慧城市建设提供核心支撑。
              </p>
            </div>
          </div>
          <div class="right">
            <div class="img">
              <img src="@img/economy/pic_dkjj_zqgj_city.png" alt="" />
            </div>
          </div>
        </div>

        <!-- <img src="@img/economy/bg_white_b.png" alt="" /> -->

        <div class="scene1">
          <div class="product3"></div>
          <div class="scene">
            <div class="top">
              <div class="left">
                <div class="title-e">Application scenario</div>
                <div class="title-c">应用场景</div>
              </div>
              <div class="right">
                <div>
                  <img
                  class="rigimgs"
                    @click="prev('left')"
                    :src="isActive === 'left' ? leftPrev : leftNor"
                    alt=""
                    @mouseenter.stop="leftmouseenter"
                    @mouseleave.stop="leftmouseleave"
                  />
                  <img
                          class="rigimgs"
                    @click="next('right')"
                    :src="isActive === 'right' ? rightPrev : rightNor"
                    alt=""
                    @mouseenter.stop="rightmouseenter"
                    @mouseleave.stop="rightmouseleave"
                  />
                </div>
              </div>
            </div>
            <div class="carousel-container">
              <div class="carousel">
                <div
                  v-for="(image, index) in visibleImages"
                  :key="index"
                  class="carousel-item"
                  :class="{
                    'hidden-left': isSmallScreen && index === 0,
                    'hidden-right': isSmallScreen && index === 4,
                    center: index === 2,
                  }"
                >
                  <img class="lunbotu" :src="image" alt="Carousel Image" />
                </div>
              </div>
            </div>
            <div class="psp">
              <div class="image-containers"  @mouseenter.stop="handleMouseEnter('left')"
                  @mouseleave="handleMouseLeave"  v-if="!UAV_RightHover">
                <div class="containers">
                  <div class="image-containers-1">双机吊挂</div>
                  <div class="image-containers-2">载荷200-600KG</div>
                </div>
              </div>
              <div class="image-containerss"  @mouseenter.stop="handleMouseEnter('right')"
                  @mouseleave="handleMouseLeave"  v-if="UAV_RightHover">
                <div class="containers" >
                  <div class="image-containers-1">机机中继</div>
                  <div class="image-containers-2">管控半径100-300KM</div>
                </div>
              </div>
           
              <div class="image-container">
                 <div class="shuangji" v-if="UAV_RightHover">双机吊挂</div>
              <div class="jij" v-if="!UAV_RightHover">机机中继</div>
                <div
                  class="image-left"
                  :class="{ 'small-image': UAV_RightHover }"
                  @mouseenter.stop="handleMouseEnter('left')"
                  @mouseleave="handleMouseLeave"
                >
                  <img
                    :src="UAV_RightHover ? UAVnor : UAVpre"
                    alt="Left Image"
                  />
                </div>
                <div
                  class="image-right"
                  :class="{ 'large-image': UAV_RightHover }"
                  @mouseenter.stop="handleMouseEnter('right')"
                  @mouseleave="handleMouseLeave"
                >
                  <img
                    :src="UAV_RightHover ? UAVnext : UAVnextNor"
                    alt="Right Image"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="AUV">
          <div class="title">
            <img
              class="auvimg"
              src="../../public/img/economy/pic_dkjj_uavcpjz_title.png"
              alt=""
            />
          </div>
          <div class="type">
            <div
              class="AUV_type"
              @click="changeActive('1')"
              :class="activeAUV === '1' ? 'active_AUV_type' : ''"
            >
              多旋翼&直升机
              <div class="underline" v-if="activeAUV === '1'">
                <img src="../../public/img/economy/AUV_active.png" alt="" />
              </div>
            </div>
            <div
              class="AUV_type"
              @click="changeActive('2')"
              :class="activeAUV === '2' ? 'active_AUV_type' : ''"
            >
              复合翼
              <div class="underline" v-if="activeAUV === '2'">
                <img src="../../public/img/economy/AUV_active.png" alt="" />
              </div>
            </div>
            <div
              class="AUV_type"
              @click="changeActive('3')"
              :class="activeAUV === '3' ? 'active_AUV_type' : ''"
            >
              边缘计算黑盒
              <div class="underline" v-if="activeAUV === '3'">
                <img src="../../public/img/economy/AUV_active.png" alt="" />
              </div>
            </div>
          </div>
          <div class="label" v-if="activeAUV === '2' || activeAUV === '1'">
            <div class="label_item" v-for="item in AUV_label" :key="item.name">
              <img class="icons" :src="item.img" alt="" />
              <span class="label_itemsp"> {{ item.name }} </span>
            </div>
          </div>
          <div class="height1-outer">
            <div class="height1" v-if="activeAUV === '1'">
              <div
                class="helicopter"
                v-for="(item, index) in helicopterList"
                :key="index"
              >
                <div class="helicopters">
                  <div class="helicopter1">
                    <img class="helicopter1-1" :src="item.img" alt="" />
                  </div>
                  <div class="helicopter1">
                    {{ item.version }}
                  </div>
                  <div class="helicopter1">
                    {{ item.size }}
                  </div>
                  <div class="helicopter1">
                    {{ item.load }}
                  </div>
                  <div class="helicopter1">
                    {{ item.endurance }}
                  </div>
                  <div class="helicopter1">
                    {{ item.wind }}
                  </div>
                  <div class="helicopter1">
                    {{ item.range }}
                  </div>
                </div>
              </div>
            </div>
            <div class="height1" ref="scrollContent" :class="{'hide-native-scrollbar': activeAUV === '2'}" v-if="activeAUV === '2'">
              <div
                class="helicopter"
                v-for="(item, index) in verticalList"
                :key="index"
              >
                <div class="helicopters">
                  <div class="helicopter1">
                    <img class="helicopter1-1" :src="item.img" alt="" />
                  </div>
                  <div class="helicopter1">
                    {{ item.version }}
                  </div>
                  <div class="helicopter1">
                    {{ item.size }}
                  </div>
                  <div class="helicopter1">
                    {{ item.load }}
                  </div>
                  <div class="helicopter1">
                    {{ item.endurance }}
                  </div>
                  <div class="helicopter1">
                    {{ item.wind }}
                  </div>
                  <div class="helicopter1">
                    {{ item.range }}
                  </div>
                </div>
              </div>
              <div
                class="custom-scrollbar"
                :style="customScrollbarStyle"
                @mousedown="startDrag"
              ></div>
              <!-- <div class="scroll-visual-bar" :style="scrollVisualBarStyle"></div> -->
            </div>
            <div class="height1" v-if="activeAUV === '3'">
              <div class="height1-1">
                <div
                  class="height1-2"
                  v-for="item in AUV_labels"
                  :key="item.name"
                >
                  <img class="icons" :src="item.img" alt="" />
                  <span class="label_itemsp"> {{ item.name }} </span>
                </div>
                <div class="height1-3">
                  <div
                    class="blackcopter"
                    v-for="(item, index) in blackBosList"
                    :key="index"
                  >
                    <div class="blackcopters">
                      <div class="blackcopter1">
                        <img class="helicopter1-1" :src="item.img" alt="" />
                      </div>
                      <div class="blackcopter1">
                        {{ item.version }}
                      </div>
                      <div class="blackcopter1">
                        {{ item.power }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="product">
            <div class="titleproduct">
              <div class="title-e">Product advantage</div>
              产品<span class="titleproduct1">优势</span>
            </div>
            <div class="navlist">
              <div class="navlist1">
                <div class="navlist1-1">
                  <img
                    class="navlist1-1-1"
                    src="../../public/img/economy/icon_dkjj_cpys_kfzkgr.png"
                    alt=""
                  />
                </div>
                <div class="navlist1-2">抗反制抗干扰</div>
                <div class="navlist1-3">
                  专有传感器+闭环姿态算法,可在诱骗、信号受干扰或卫星拒止环境下保持安全飞行。
                </div>
              </div>

              <div class="navlist2">
                <div class="navlist1-1">
                  <img
                    src="../../public/img/economy/icon_dkjj_cpys_aiar.png"
                    alt=""
                    class="navlist1-1-1"
                  />
                </div>
                <div class="navlist1-2">AI+AR</div>
                <div class="navlist1-3">
                  运用AI技术，可对采集的数据实时处理分析，实现对目标自动检测、识别与追踪。结合AR技术，可叠加交通路网、输电线网、地下管线等特定数据至视频画面。
                </div>
              </div>
              <div class="navlist3">
                <div class="navlist1-1">
                  <img
                    src="../../public/img/economy/icon_dkjj_cpys_zzwsjl.png"
                    alt=""
                    class="navlist1-1-1"
                  />
                </div>
                <div class="navlist1-2">自组网数据链</div>
                <div class="navlist1-3">
                  标配50-100km自组网数据链，无人机支持"机-机中继"技术，传输距离可扩展至300+km。
                </div>
              </div>
              <div class="navlist4">
                <div class="navlist1-1">
                  <img
                    src="../../public/img/economy/icon_dkjj_cpys_znfzxt.png"
                    alt=""
                    class="navlist1-1-1"
                  />
                </div>
                <div class="navlist1-2">智能防撞系统</div>
                <div class="navlist1-3">
                  该系统集成全国范围的DSM(数字地表模型)，结合风速、气压，无人机转弯半径和爬升率等动态特性，实时动态对无人机任务航线进行智能安全调整，保障飞行安全。
                </div>
              </div>
              <div class="navlist5">
                <div class="navlist1-1">
                  <img
                    src="../../public/img/economy/icon_dkjj_cpys_djxt.png"
                    alt=""
                    class="navlist1-1-1"
                  />
                </div>
                <div class="navlist1-2">多机协同</div>
                <div class="navlist1-3">
                  通过通信技术、控制算法、定位及导航技术，实现多架无人机之间的相互通信、协同配合，高效完成作业任务。
                </div>
              </div>
              <div class="navlist6">
                <div class="navlist1-1">
                  <img
                    src="../../public/img/economy/icon_dkjj_cpys_ygjqzw.png"
                    alt=""
                    class="navlist1-1-1"
                  />
                </div>
                <div class="navlist1-2">异构集群组网</div>
                <div class="navlist1-3">
                  支持多旋翼、复合翼、无人直升机等不同类型的无人机进行异构集群组网，组成察打一体化解决方案。
                </div>
              </div>
              <div class="navlist7">
                <div class="navlist1-1">
                  <img
                    src="../../public/img/economy/icon_dkjj_cpys_dptqj.png"
                    alt=""
                    class="navlist1-1-1"
                  />
                </div>
                <div class="navlist1-2">动平台起降+异地起降</div>
                <div class="navlist1-3">
                  内置抗干扰传感器，支持在高速移动或复杂海况等非平稳状态下的起降，可支持100km以上异地起降。
                </div>
              </div>
              <div class="navlist8">
                <div class="navlist1-1">
                  <img
                    src="../../public/img/economy/icon_dkjj_cpys_sydaqfk.png"
                    alt=""
                    class="navlist1-1-1"
                  />
                </div>
                <div class="navlist1-2">三余度安全飞控</div>
                <div class="navlist1-3">
                  飞控系统采用三冗余设计，具备三套互相独立的传感器，具有气压高度、惯性测量、导航定位、航向测量等功能，三套传感器独立工作，支持仲裁决策，互为备份。
                </div>
              </div>
            </div>
            <div class="product1"></div>
            <div class="product2"></div>
          </div>
          <div class="jichu">
            <div>
              <img
                src="../../public/img/economy/pic_dkjj_gjdkjcss_title.png"
                alt=""
                class="jichu1"
              />
            </div>
            <div>
              <img
                src="../../public/img/economy/pic_dkjj_gjdkjcss.png"
                alt=""
                class="jichu2"
              />
            </div>
          </div>
          <div class="UAV">
            <div class="UAV1">
              <div class="title-e">UAV AI+ Technological innovation</div>
              <span class="UAV1-1">UAV AI+ 技术</span>
              <span class="UAV1-2">创新</span>
            </div>
            <div class="UAV2">
              <div class="UAV2-1">
                <span class="UAV2-1-1"
                  ><img
                    src="../../public/img/economy/icon_dkjj_jscx_kskzjzspg.png"
                    alt=""
                    class="UAV2-1-1-1"
                /></span>
                <span class="UAV2-1-2">快速勘灾及灾损评估</span>
              </div>
              <div class="UAV2-1">
                <span class="UAV2-1-1"
                  ><img
                    src="../../public/img/economy/icon_dkjj_jscx_gtqxjc.png"
                    alt=""
                    class="UAV2-1-1-1"
                /></span>
                <span class="UAV2-1-2">杆塔倾斜监测和预判</span>
              </div>
              <div class="UAV2-1">
                <span class="UAV2-1-1"
                  ><img
                    src="../../public/img/economy/icon_dkjj_jscx_xsxaipd.png"
                    alt=""
                    class="UAV2-1-1-1"
                /></span>
                <span class="UAV2-1-2">X射线AI判读</span>
              </div>
              <div class="UAV2-1">
                <span class="UAV2-1-1"
                  ><img
                    src="../../public/img/economy/icon_dkjj_jscx_hwsbycjzpd.png"
                    alt=""
                    class="UAV2-1-1-1"
                /></span>
                <span class="UAV2-1-2">红外设备异常精准判读及预测</span>
              </div>
              <div class="UAV2-1">
                <span class="UAV2-1-1"
                  ><img
                    src="../../public/img/economy/icon_dkjj_jscx_pwqyksxj.png"
                    alt=""
                    class="UAV2-1-1-1"
                /></span>
                <span class="UAV2-1-2">配网全域快速巡检</span>
              </div>
              <div class="UAV2-1">
                <span class="UAV2-1-1"
                  ><img
                    src="../../public/img/economy/icon_dkjj_jscx_znfzpz.png"
                    alt=""
                    class="UAV2-1-1-1"
                /></span>
                <span class="UAV2-1-2">智能辅助拍照</span>
              </div>
              <div class="UAV2-1">
                <span class="UAV2-1-1"
                  ><img
                    src="../../public/img/economy/icon_dkjj_jscx_xxlys.png"
                    alt=""
                    class="UAV2-1-1-1"
                /></span>
                <span class="UAV2-1-2">新线路验收</span>
              </div>
              <div class="UAV2-1">
                <span class="UAV2-1-1"
                  ><img
                    src="../../public/img/economy/icon_dkjj_jscx_ddxfxfx.png"
                    alt=""
                    class="UAV2-1-1-1"
                /></span>
                <span class="UAV2-1-2">导地线仿线飞巡</span>
              </div>
              <div class="UAV2-1">
                <span class="UAV2-1-1"
                  ><img
                    src="../../public/img/economy/icon_dkjj_jscx_sdzsyxj.png"
                    alt=""
                    class="UAV2-1-1-1"
                /></span>
                <span class="UAV2-1-2">输电自适应巡检</span>
              </div>
              <div class="UAV2-1">
                <span class="UAV2-1-1"
                  ><img
                    src="../../public/img/economy/icon_dkjj_jscx_pdzsyxj.png"
                    alt=""
                    class="UAV2-1-1-1"
                /></span>
                <span class="UAV2-1-2">配电自适应巡检</span>
              </div>
              <div class="UAV2-1">
                <span class="UAV2-1-1"
                  ><img
                    src="../../public/img/economy/icon_dkjj_jscx_tdrcxj.png"
                    alt=""
                    class="UAV2-1-1-1"
                /></span>
                <span class="UAV2-1-2">通道日常巡检</span>
              </div>
              <div class="UAV2-1">
                <span class="UAV2-1-1"
                  ><img
                    src="../../public/img/economy/icon_dkjj_jscx_manus.png"
                    alt=""
                    class="UAV2-1-1-1"
                /></span>
                <span class="UAV2-1-2">基于Manus技术的智能体构建</span>
              </div>
            </div>
            <div class="product3"></div>
          </div>
          <div class="FREE">
            <div class="frees">
              <img
                class="frees"
                src="../../public/img/economy/Group544.png"
                alt=""
              />
            </div>
            <div class="frees1">
              <img
                class="frees1"
                src="../../public/img/economy/Group542.png"
                alt=""
              />
            </div>
            <div class="FREE1">
              <div class="FREE1-1">
                免费获取方案
                <div class="FREE1-1-1">FREE</div>
                <div class="FREE1-1-1">ACCESS</div>
                <div class="FREE1-1-1">PLAN</div>
              </div>
              <div class="FREE1-2">
                <div class="FREE1-2-1">
                  <span class="fixed-text">姓名:</span>
                  <input
                    class="FREE1-2-1-1"
                    v-model="params.realName"
                    type="text"
                  />
                </div>
                <div class="FREE1-2-1">
                  <span style="padding-left: 20px;" class="fixed-text"
                    >电话:</span
                  >
                  <input
                    class="FREE1-2-1-1"
                    v-model="params.mobile"
                    type="text"
                  />
                </div>
                <div class="FREE1-2-2">
                  <span class="fixed-text">留言:</span>
                  <input
                    class="FREE1-2-1-1"
                    v-model="params.remark"
                    type="text"
                  />
                </div>
                <div class="FREE1-2-2">
                  <input
                    class="FREE1-2-1-2"
                    @click="submit"
                    value="提交信息"
                    type="button"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="sider">
            <div class="sider1"></div>
            <div class="sider2">
              <div>
                <div class="sider2-1">
                  <div class="sider2-2">
                    <img
                      class="sider2-2-1"
                      src="../../public/img/economy/ic_dkjj_sh_dz_org.png"
                      alt=""
                    />
                  </div>
                  <div class="sider2-3">
                    <div class="sider2-3-1">定制专属方案</div>
                    <div class="sider2-3-2">
                      专业的售前、售后客户经理1V1在线答疑。
                    </div>
                  </div>
                </div>
                <div class="sider2-1">
                  <div class="sider2-2">
                    <img
                      class="sider2-2-1"
                      src="../../public/img/economy/ic_dkjj_sh_zc_org.png"
                      alt=""
                    />
                  </div>
                  <div class="sider2-3">
                    <div class="sider2-3-1">专业技术支撑</div>
                    <div class="sider2-3-2">为客户量身定制专属解决方案。</div>
                  </div>
                </div>
                <div class="sider2-1">
                  <div class="sider2-2">
                    <img
                      class="sider2-2-1"
                      src="../../public/img/economy/ic_dkjj_sh_dz_org.png"
                      alt=""
                    />
                  </div>
                  <div class="sider2-3">
                    <div class="sider2-3-1">快速排除故障</div>
                    <div class="sider2-3-2">反应迅速，及时解决故障。</div>
                  </div>
                </div>
                <div class="sider2-1">
                  <div class="sider2-2">
                    <img
                      class="sider2-2-1"
                      src="../../public/img/economy/ic_dkjj_sh_fw_org.png"
                      alt=""
                    />
                  </div>
                  <div class="sider2-3">
                    <div class="sider2-3-1">7x24小时服务</div>
                    <div class="sider2-3-2">
                      7×24小时在线，全年不间断提供服务。
                    </div>
                  </div>
                </div>
              </div>
              <div class="bor"></div>
            </div>
            <div class="sider3">
              <div class="sider3-1">
                <div class="sider3-1-1">
                  <span class="sider3-1-1-1">
                    <img
                      class="siderbaner"
                      src="../../public/img/economy/pic_dkjj_logo.png"
                      alt=""
                  /></span>
                  <span class="sider3-1-1-2"
                    >让科技为生活赋能，让信息为发展加速。</span
                  >
                </div>
                <div class="sider3-1-2">
                  <span class="sider3-1-2-1"
                    >Copyright © 2019 - 2022 Yunbai Technology. All Rights
                    Reserved.</span
                  >
                  <span class="sider3-1-2-2">云百科技 版权所有</span>
                </div>
                <div class="sider3-1-3">
                  <span class="sider3-1-3-1"
                    >广东云百科技有限公司 | <a href="https://beian.miit.gov.cn"
                    target="_blank" rel="noopener noreferrer">粤ICP备2020131390号</a></span
                  >
                </div>
              </div>
              <div class="sider3-2">
                <div class="sider3-2-1">
                  <span class="sider3-2-1-1"
                    ><img
                      src="../../public/img/economy/ic_dkjj_a_fwrx.png"
                      alt=""
                  /></span>
                  <span class="sider3-2-1-2">服务热线：</span>
                </div>
                <div class="sider3-2-2">0 7 6 9 - 8 9 0 0 8 9 0 0</div>
                <div class="sider3-2-3">
                  <span class="sider3-2-3-1"
                    ><img
                      src="../../public/img/economy/ic_dkjj_a_gsdz.png"
                      alt=""
                  /></span>
                  <span class="sider3-2-3-2">公司地址：</span>
                </div>
                <div class="sider3-2-4">
                  广东省东莞市南城街道中熙时代大厦9楼
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import Head from "../components/head.vue";
import planDialog from "../components/planDialog.vue";
import mixin from "@/mixin/index.js";
import dkjjimg from "./dkjjimg.vue";        
export default {
  mixins: [mixin],
  data() {
    return {
      remark: "",
      mobile: "",
      realName: "",
      is_active: 0,
      topBannerList: [],
      isShow: false,
      bannerData: [
        {
          title: "",
          content: "",
          button: "",
          img: require("@img/economy/banner.png"),
          banner: "economy",
        },
      ],
      leftPrev: require("@img/economy/btn_dkjj_left_pre.png"),
      leftNor: require("@img/economy/btn_dkjj_left_nor.png"),
      rightPrev: require("@img/economy/btn_dkjj_right_pre.png"),
      rightNor: require("@img/economy/btn_dkjj_right_nor.png"),
      isActive: "",
      currentIndex: 0,
      intervalId: null, // 用于存储定时器 ID
      timeoutId: null, // 用于存储延迟开启轮播的定时器 ID
      isSmallScreen: false, // 是否是小屏幕
      images: [
        require("@img/economy/1.png"),
        require("@img/economy/2.png"),
        require("@img/economy/3.png"),
        require("@img/economy/4.png"),
        require("@img/economy/5.png"),
        require("@img/economy/6.png"),
        require("@img/economy/7.png"),
        require("@img/economy/8.png"),
        require("@img/economy/9.png"),
      ],
      mousestate: false,
      UAV_RightHover: false,
      UAVpre: require("@img/economy/left_pre.png"),
      UAVnor: require("@img/economy/left_nor.png"),
      UAVnext: require("@img/economy/right_pre.png"),
      UAVnextNor: require("@img/economy/right_nor.png"),
      activeAUV: "1", // 初始选中的 AUV 类型
      blackBosList: [
        {
          img: require("@img/altitude/YB-1000.png"),
          version: "YB-1000",
          power: "15 TOPS",
        },
        {
          img: require("@img/altitude/YB-2000.png"),
          version: "YB-2000",
          power: "100 TOPS",
        },
      ],

      AUV_label: [
        { name: "型号", img: require("@img/economy/xinghao.png") },
        { name: "尺寸", img: require("@img/economy/chicun.png") },
        { name: "载荷能力", img: require("@img/economy/zhaihe.png") },
        { name: "续航时间", img: require("@img/economy/xuhang.png") },
        { name: "抗风等级", img: require("@img/economy/kangfeng.png") },
        { name: "测控距离", img: require("@img/economy/cekong.png") },
      ],
      AUV_labels: [
        { name: "型号", img: require("@img/economy/xinghao.png") },
        { name: "算力", img: require("@img/economy/suanli.png") },
      ],
      helicopterList: [
        {
          img: require("@img/altitude/YB-550X.png"),
          version: "YB-550X",
          size: "3.5x3.5m",
          load: "350kg",
          endurance: "15min",
          wind: "15m/s",
          range: "30+km",
        },
        {
          img: require("@img/altitude/YB-25H.png"),
          version: "YB-25H",
          size: "1.8x0.364x0.729m",
          load: "10kg",
          endurance: "2.5h",
          wind: "15m/s",
          range: "50km",
        },
        {
          img: require("@img/altitude/YB-600H.png"),
          version: "YB-600H",
          size: "5.62x3.61x1.2m",
          load: "300kg",
          endurance: "5h",
          wind: "15m/s",
          range: "100+km",
        },
      ],
      verticalList: [
        {
          img: require("@img/altitude/YB-T10.png"),
          version: "YB-T10",
          size: "4.20x2.01m",
          load: "10kg",
          endurance: "90min",
          wind: "15m/s",
          range: "50+km",
        },
        {
          img: require("@img/altitude/YB-T50.png"),
          version: "YB-T50",
          size: "6.50x3.26m",
          load: "50kg",
          endurance: "2h",
          wind: "15m/s",
          range: "50+km",
        },
        {
          img: require("@img/altitude/YB-13VN.png"),
          version: "YB-13VN",
          size: "3.00x1.77m",
          load: "3kg",
          endurance: "3h",
          wind: "8m/s",
          range: "50+km",
        },
        {
          img: require("@img/altitude/YB-20V.png"),
          version: "YB-20V",
          size: "3.50x1.75m",
          load: "5kg",
          endurance: "3h",
          wind: "13m/s",
          range: "50+km",
        },
        {
          img: require("@img/altitude/YB-25V.png"),
          version: "YB-25V",
          size: "4.13x1.93m",
          load: "10kg",
          endurance: "4h",
          wind: "15m/s",
          range: "50+km",
        },
        {
          img: require("@img/altitude/YB-25Vs.png"),
          version: "YB-25VS",
          size: "4.13x1.93m",
          load: "10kg",
          endurance: "4h",
          wind: "15m/s",
          range: "100+km",
        },
        {
          img: require("@img/altitude/YB-60V.png"),
          version: "YB-60V",
          size: "4.80x2.65m",
          load: "20kg",
          endurance: "4h",
          wind: "15m/s",
          range: "50km",
        },
        {
          img: require("@img/altitude/YB-120V.png"),
          version: "YB-120V",
          size: "6.50x3.26m",
          load: "40kg",
          endurance: "8h",
          wind: "15m/s",
          range: "100+km",
        },
      ],
      isAtBottom: false,
      isDragging: false,
      dragStartY: 0,
      scrollStartTop: 0,
      customScrollbarStyle: {
        height: '40px',
        top: '0px',
        display: 'none',
      },
    };
  },
  components: {
    Head,
    planDialog, 
    dkjjimg
  },
  computed: {
    visibleImages() {
      const length = this.images.length;
      const start = this.currentIndex;
      const end = start + 5;
      if (end <= length) {
        return this.images.slice(start, end);
      } else {
        return [
          ...this.images.slice(start, length),
          ...this.images.slice(0, end - length),
        ];
      }
    },
  },
  created() {},
  mounted() {
    this.checkScreenSize(); // 初始化屏幕尺寸检查
    this.startAutoPlay(); // 初始化自动轮播
    window.addEventListener("resize", this.checkScreenSize); // 监听窗口大小变化
    this.$nextTick(() => {
      // 只监听当前显示的.height1
      this.addScrollListener();
      this.updateCustomScrollbar();
      window.addEventListener('mousemove', this.onDrag);
      window.addEventListener('mouseup', this.stopDrag);
      this.addCustomScrollListener();
    });
  },
  watch: {
    activeAUV() {
      this.$nextTick(() => {
        this.updateCustomScrollbar();
        this.addCustomScrollListener();
      });
    }
  },
  beforeDestroy() {
    clearInterval(this.intervalId); // 组件销毁时清除定时器
    clearTimeout(this.timeoutId); // 组件销毁时清除延迟定时器
    window.removeEventListener("resize", this.checkScreenSize); // 移除监听
    this.removeScrollListener();
    window.removeEventListener('mousemove', this.onDrag);
    window.removeEventListener('mouseup', this.stopDrag);
    this.removeCustomScrollListener();
  },
  methods: {
    btnclk() {
      this.isShow = true;
    },
    closeTop() {
      this.isShow = false;
    },
    changeActive(val) {
      this.activeAUV = val; // 更新选中的 AUV 类型
    },
    // 检查屏幕尺寸
    checkScreenSize() {
      this.isSmallScreen = window.innerWidth <= 1200; // 判断是否是小屏幕
    },
    startAutoPlay() {
      this.intervalId = setInterval(this.next, 1000); // 启动自动轮播
    },
    stopAutoPlay() {
      clearInterval(this.intervalId); // 停止自动轮播
    },
    delayAutoPlay() {
      clearInterval(this.intervalId); // 清除之前的定时器
      clearTimeout(this.timeoutId); // 清除之前的延迟定时器
      this.timeoutId = setTimeout(() => {
        this.startAutoPlay(); // 延迟 5 秒后启动自动轮播
      }, 5000);
    },
    leftmouseenter() {
  
        this.isActive = "left";
 
    },
    rightmouseenter() {
    
        this.isActive = "right";
 
    },
    leftmouseleave() {
  
        this.isActive = "";
     
    },
      rightmouseleave(){
    
        this.isActive = "";
   
    },
    prev(val) {
      // this.isActive = "left";
      this.currentIndex =
        (this.currentIndex - 1 + this.images.length) % this.images.length;
      if (val === "left") {
        this.delayAutoPlay(); // 延迟开启轮播

      }
    },
    next(val) {
      // this.isActive = "right";
      this.currentIndex = (this.currentIndex + 1) % this.images.length;
      if (val === "right") {
        this.delayAutoPlay(); // 延迟开启轮播

      }
    },
    handleMouseEnter(side) {
      if (this.hoverTimeout) {
        clearTimeout(this.hoverTimeout);
      }
      this.hoverTimeout = setTimeout(() => {
        this.UAV_RightHover = side === 'right';
      }, 50);
    },
    handleMouseLeave() {
      if (this.hoverTimeout) {
        clearTimeout(this.hoverTimeout);
      }
      this.hoverTimeout = setTimeout(() => {
        this.UAV_RightHover = false;
      }, 50);
    },
    addScrollListener() {
      this.removeScrollListener();
      const el = this.$el.querySelector('.height1');
      if (el) {
        el.addEventListener('scroll', this.checkScrollBottom);
        this.checkScrollBottom();
        this._scrollEl = el;
      }
    },
    removeScrollListener() {
      if (this._scrollEl) {
        this._scrollEl.removeEventListener('scroll', this.checkScrollBottom);
        this._scrollEl = null;
      }
    },
    checkScrollBottom() {
      const el = this.$el.querySelector('.height1');
      if (!el) return;
      // 允许1px误差
      this.isAtBottom = (el.scrollTop + el.clientHeight >= el.scrollHeight - 1);
    },
    addCustomScrollListener() {
      this.removeCustomScrollListener();
      if (this.activeAUV === '2') {
        const el = this.$refs.scrollContent;
        if (el) {
          el.addEventListener('scroll', this.updateCustomScrollbar);
          this.updateCustomScrollbar();
          this._customScrollEl = el;
        }
      }
    },
    removeCustomScrollListener() {
      if (this._customScrollEl) {
        this._customScrollEl.removeEventListener('scroll', this.updateCustomScrollbar);
        this._customScrollEl = null;
      }
    },
    updateCustomScrollbar() {
      if (this.activeAUV !== '2') {
        this.customScrollbarStyle.display = 'none';
        return;
      }
      this.$nextTick(() => {
        const el = this.$refs.scrollContent;
        if (!el) return;
        const ratio = el.clientHeight / el.scrollHeight;
        const barHeight = Math.max(40, el.clientHeight * ratio);
        const percent = el.scrollTop / (el.scrollHeight - el.clientHeight);
        const top = percent * (el.clientHeight - barHeight);
        this.customScrollbarStyle = {
          height: barHeight + 'px',
          top: top + 'px',
          right: '2px',
          display: el.scrollHeight > el.clientHeight ? 'block' : 'none',
        };
      });
    },
    startDrag(e) {
      if (this.activeAUV !== '2') return;
      this.isDragging = true;
      this.dragStartY = e.clientY;
      const el = this.$refs.scrollContent;
      this.scrollStartTop = el ? el.scrollTop : 0;
      e.preventDefault();
    },
    onDrag(e) {
      if (!this.isDragging || this.activeAUV !== '2') return;
      const el = this.$refs.scrollContent;
      if (!el) return;
      const ratio = (el.scrollHeight - el.clientHeight) / (el.clientHeight - parseFloat(this.customScrollbarStyle.height));
      const deltaY = e.clientY - this.dragStartY;
      el.scrollTop = this.scrollStartTop + deltaY * ratio;
    },
    stopDrag() {
      this.isDragging = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.whiteup {
  position: relative;
  margin: 0 auto;
  margin-top: -90px;
  height: 90px;
  width: 70%;
  background: #fff;
  z-index: 999;
  &::before {
    position: absolute;
    left: -90px;
    content: "";
    width: 0;
    height: 0;
    border-top: 45px solid transparent;
    border-left: 45px solid transparent;
    border-right: 45px solid #fff;
    border-bottom: 45px solid #fff;
    z-index: 999;
  }
  &::after {
    position: absolute;
    right: -90px;
    content: "";
    width: 0;
    height: 0;
    border-top: 45px solid transparent;
    border-left: 45px solid #fff;
    border-right: 45px solid transparent;
    border-bottom: 45px solid #fff;
    z-index: 999;
  }
}
.whiteTop {
  position: relative;
  margin: 0 auto;
  width: 100%;
  height: 90px;
  margin-top: -89px;
  z-index: 999;
  img {
    width: 100%;
    height: 90px;
  }
}
.whiteBottom {
  // position: relative;
  margin: 0 auto;
  width: 100%;
  height: 90px;
  margin-bottom: -90px;
  z-index: 999;
  img {
    width: 100%;
    height: 90px;
  }
}
.summing {
  position: relative; // 新增定位上下文
  padding: 40px 157px 40px 260px;
  height: 820px;
  .left {
    width: 50%; // 控制左边内容宽度
    z-index: 1; // 确保文字在图片上层
    .title {
      text-align: left;
    }
    .desc {
      width: 530px;
      color: rgba(28, 31, 38, 0.8);
      font-size: 16px;
      text-align: left;
      line-height: 28px;
      font-family: PingFang SC, PingFang SC-400;
    }
  }

  .right {
    position: absolute;
    right: 0;
    top: 50%; // 垂直居中
    transform: translateY(-50%);
    width: 60%; // 图片容器更宽
    z-index: 0;

    .img {
      img {
        max-width: 100%;
        height: auto;
        margin-left: 0;
      }
    }
  }
}
.scene {
  background-image: url("../../public/img/economy/pic_dkjj_yycj_bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  height: 990px;
  .top {
    display: flex;
    justify-content: space-between;
    padding: 200px 260px 60px 260px;
    .left {
      .title-e {
        opacity: 0.6;
        font-size: 12px;
        font-family: "PingFang SC", "PingFang SC-400";
        font-weight: 400;
        text-align: LEFT;
        color: #fff;
        margin-left: 5px;
      }
      .title-c {
        background: linear-gradient(to right, #ffffff, #fa9a26);
        background-clip: text;
        color: transparent;
        font-size: 48px;
        font-family: PingFang SC, PingFang SC-400;
        font-weight: 600;
        text-align: LEFT;
      }
    }
    .right {
    }
  }
}
.carousel {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 20px; /* 图片之间的间隔 */
  overflow: hidden;
  .carousel-container {
    display: flex;
    gap: 20px; /* 图片之间的间隔 */
    width: 100%;
    justify-content: center;
    transition: transform 0.5s ease;
    .carousel-item {
      flex: 0 0 calc(20% - 20px); /* 每张图片占 20% 宽度，减去间隔 */
      box-sizing: border-box;
      position: relative;
      transition: transform 0.5s ease;
    }
    .carousel-item img {
      width: 100%;
      height: auto;
      display: block;
    }
    /* 居中显示的图片 */
    .carousel-item.center {
      transform: scale(1.1); /* 放大居中图片 */
      z-index: 1; /* 确保居中图片在最上层 */
    }

    /* 隐藏第一张和第五张图片超出的部分 */
    .carousel-item.hidden-left {
      transform: translateX(-50%);
    }

    .carousel-item.hidden-right {
      transform: translateX(50%);
    }
  }
}
.image-container {
  display: flex;
  //   position: absolute;
  margin-top: 158px;
  //   width: 100%;
  padding: 0 276px;
  height: 692px; /* 根据需要调整高度 */
  gap: 10px; /* 图片之间的间距 */
  .image-left,
  .image-right {
    flex: 1;
    transition: all 0.3s ease;
    overflow: hidden;
    position: relative;
    height: 692px;
  }
  .image-left img,
  .image-right img {
    width: 100%;
    height: 692px;

    height: 100%;
    object-fit: cover;
    transition: all 0.3s ease;
  }
  /* 默认状态：左边图片放大，右边图片缩小 */
  .image-left {
    flex: 2; /* 左边图片占更多空间 */
    width: 100%;
    height: 100%;
  }

  .image-right {
    flex: 1; /* 右边图片占更少空间 */
    width: 100%;
    height: 100%;
  }

  /* 鼠标移入右边图片时的状态 */
  .image-right.large-image {
    flex: 2; /* 右边图片放大 */
    width: 100%;
    height: 100%;
  }

  .image-left.small-image {
    flex: 1; /* 左边图片缩小 */
    width: 100%;
    height: 100%;
  }
}
.AUV {
  //   position: relative;
  margin-top: 5%;
  .title {
  }
  .type {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 32px;
    gap: 127px;
    .AUV_type {
      color: #1c1f26;
      font-size: 24px;
      font-family: PingFang SC, PingFang SC-400;
      font-weight: 400;
      text-align: CENTER;
      min-height: 65px;
      .underline {
        margin-top: 8px;
      }
    }
    .active_AUV_type {
      font-weight: 700;
    }
  }
}
.label {
  // width:1080px;
  width: 100%;
  margin-top: 91px;
  .label_item {
    // margin-left: 559px;
    display: inline-block;
    .label_itemsp {
      line-height: 40px;
      font-size: 14px;
      font-weight: 400;
      color: rgba(28, 31, 38, 0.6);
    }
  }
  .label_item:nth-of-type(1) {
    // margin-right: 100px;
    margin-left: 7%;
    width: 270px;
  }
  .label_item:nth-of-type(2) {
    // margin-left: 198px;
    width: 186px;
  }
  .label_item:nth-of-type(3) {
    // margin-left: 114px;
    width: 170px;
  }
  .label_item:nth-of-type(4) {
    width: 170px;
    // margin-left: 70px;
  }
  .label_item:nth-of-type(5) {
    width: 170px;
    // margin-left: 70px;
  }
  .label_item:nth-of-type(6) {
    width: 170px;
    // margin-left: 70px;
  }
}
// .helicopter:nth-child(odd){
//     background-color: #eee9e9;
//     background-size: 1400px 136px;
//     width: 100%;
//     height: 136px;
//     text-align: center;
//     margin: 0 auto;
//   }

.helicopter {
  /* 超过高度时显示滚动条，不超过则隐藏 */
  // margin-top: 20px;
  // text-align: center;

  position: relative;
  width: 100%;
  .helicopters {
    // margin: 0 auto;
  }

  .helicopters:hover {
    background-image: url("../../public/img/economy/pic_dkjj_uavcpjz_cp_pre.png");
    background-repeat: no-repeat;
    background-size: 1400px 136px;
    width: 100%;
    height: 136px;
    text-align: center;
    background-position: 220px 0;
  }
  .helicopter1 {
    font-size: 18px;
    height: 136px;
    width: 170px;
    display: inline-block;
    text-align: center;
    line-height: 136px;
    // margin-left: 30px;
  }
  .helicopter1:nth-of-type(1) {
    width: 266px;
  }
  .helicopter1:nth-of-type(2) {
    // margin-left: 7%;
    width: 270px;
    font-size: 32px;
    font-weight: 700;
    // color: rgba(28, 31, 38, 0.6);
    // margin-right: 130px;
  }
  .helicopter1:nth-of-type(3) {
    // margin-left: 7%;
    color: rgba(28, 31, 38, 0.6);
  }
  .helicopter1:nth-of-type(4) {
    // width:240px;
    // width: 220px;
    // margin-left: 40px;
    // padding-left: 50px;
    // width: 100px;
    width: 170px;
    color: rgba(28, 31, 38, 0.6);
  }
  .helicopter1:nth-of-type(5) {
    // width:240px;
    // width: 220px;
    // margin-left: 40px;
    // padding-left: 50px;
    // width: 100px;
    width: 170px;
    color: rgba(28, 31, 38, 0.6);
  }
  .helicopter1:nth-of-type(6) {
    // width:240px;
    // width: 220px;
    // margin-left: 40px;
    // padding-left: 50px;
    // width: 100px;
    width: 170px;
    color: rgba(28, 31, 38, 0.6);
  }
  .helicopter1:nth-of-type(7) {
    // width:240px;
    width: 170px;
    color: rgba(28, 31, 38, 0.6);

    // width: 220px;
    // margin-left: 40px;
    // padding-left: 50px;
    margin-right: 110px;
  }
}

.height1 {
  width: 100%;
  min-height: 500px;
  max-height: 814px;
  overflow-y: auto;
}
.height1.hide-native-scrollbar {
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE 10+ */
}
.height1.hide-native-scrollbar::-webkit-scrollbar {
  display: none;
}
.height1::-webkit-scrollbar {
  width: 6px;
  background: transparent;
}
.height1::-webkit-scrollbar-thumb {
  background: rgba(0,0,0,0.15);
  border-radius: 4px;
}
.height1::-webkit-scrollbar-track {
  background: transparent;
}
.height1 {
  .height1-1 {
    margin-top: 91px;
    .height1-2 {
      width: 610px;
      display: inline-block;
      line-height: 40px;
    }
  }
}
.blackcopter {
  /* 超过高度时显示滚动条，不超过则隐藏 */
  // margin-top: 20px;
  .blackcopters:hover {
    background-image: url("../../public/img/economy/pic_dkjj_uavcpjz_cp_pre.png");
    background-size: 1400px 136px;
    background-repeat: no-repeat;
    width: 100%;
    height: 136px;
    text-align: center;
    background-position: 150px 0;
  }
  .blackcopter1 {
    font-size: 18px;
    height: 136px;
    width: 170px;
    display: inline-block;
    text-align: center;
    line-height: 136px;
    // margin-left: 30px;
  }
  .blackcopter1:nth-of-type(1) {
    width: 266px;
  }
  .blackcopter1:nth-of-type(2) {
    // margin-left: 7%;
    width: 270px;
    font-size: 32px;
    font-weight: 700;
    margin-right: 400px;
    // color: rgba(28, 31, 38, 0.6);
    // margin-right: 130px;
  }
  .blackcopter1:nth-of-type(3) {
    // margin-left: 7%;
    color: rgba(28, 31, 38, 0.6);
    margin-right: 310px;
  }
}
.image-containers {
  z-index: 80;
  width: 876px;
  height: 134px;
  background: linear-gradient(0deg, #0159cc 0%, rgba(0, 99, 230, 0));
  border-radius: 0px 0px 8px 8px;
  position: absolute;
  top: 4%;
  left: 15%;
  color: #ffffff;
  pointer-events: none;
  .containers {
    text-align: left;
    margin-left: 16px;
    .image-containers-1 {
      font-size: 36px;
      font-weight: 400;
    }
    .image-containers-2 {
      font-size: 24px;
      font-weight: 400;
    }
  }
}
.image-containerss {
  z-index: 80;
  width: 876px;
  height: 134px;
  background: linear-gradient(0deg, #0159cc 0%, rgba(0, 99, 230, 0));
  border-radius: 0px 0px 8px 8px;
  position: absolute;
  top: 4%;
  right: 15%;
  color: #ffffff;
  .containers {
    text-align: left;
    margin-left: 16px;
    .image-containers-1 {
      font-size: 36px;
      font-weight: 400;
    }
    .image-containers-2 {
      font-size: 24px;
      font-weight: 400;
    }
  }
}
.psp {
  position: relative;
}
.jij {
  z-index: 1000;
  position: absolute;
  top: 6%;
  right: 29%;
  font-size: 36px;
  font-weight: 400;
  color: #ffffff;
}
.shuangji {
  z-index: 1000;
  position: absolute;
  top: 6%;
  left: 16%;
  font-size: 36px;
  font-weight: 400;
  color: #ffffff;
}

.product {
  margin-top: 10px;
  background-image: url("../../public/img/economy/pic_dkjj_cpys_bg.png");
  background-repeat: no-repeat;
  background-size: cover;

  width: 100%;
  height: 1200px;
  position: relative;
  .title-e {
        opacity: 0.6;
        font-size: 12px;
        font-family: "PingFang SC", "PingFang SC-400";
        font-weight: 600;
        text-align: LEFT;
        color: #fff;
        margin-left: 3px;
      }
  .navlist {
    // width: 100%;

    // position: absolute;
    // top: 250px;
    // left: 230px;
    // position: relative;
    // position: absolute;
    // top: 50px;
    .navlist8:hover {
      width: 372px;
      height: 406px;
      background-image: url("../../public/img/economy/pic_dkjj_cpys_card_pre.png");
      background-repeat: no-repeat;
      background-size: cover; /* 或者根据需要使用其他值，如contain */
    }
    .navlist7:hover {
      width: 372px;
      height: 406px;
      background-image: url("../../public/img/economy/pic_dkjj_cpys_card_pre.png");
      background-repeat: no-repeat;
      background-size: cover; /* 或者根据需要使用其他值，如contain */
    }
    .navlist6:hover {
      width: 372px;
      height: 406px;
      background-image: url("../../public/img/economy/pic_dkjj_cpys_card_pre.png");
      background-repeat: no-repeat;
      background-size: cover; /* 或者根据需要使用其他值，如contain */
    }
    .navlist5:hover {
      width: 372px;
      height: 406px;
      background-image: url("../../public/img/economy/pic_dkjj_cpys_card_pre.png");
      background-repeat: no-repeat;
      background-size: cover; /* 或者根据需要使用其他值，如contain */
    }
    .navlist4:hover {
      width: 372px;
      height: 406px;
      background-image: url("../../public/img/economy/pic_dkjj_cpys_card_pre.png");
      background-repeat: no-repeat;
      background-size: cover; /* 或者根据需要使用其他值，如contain */
    }
    .navlist3:hover {
      width: 372px;
      height: 406px;
      background-image: url("../../public/img/economy/pic_dkjj_cpys_card_pre.png");
      background-repeat: no-repeat;
      background-size: cover; /* 或者根据需要使用其他值，如contain */
    }
    .navlist2:hover {
      width: 372px;
      height: 406px;
      background-image: url("../../public/img/economy/pic_dkjj_cpys_card_pre.png");
      background-repeat: no-repeat;
      background-size: cover; /* 或者根据需要使用其他值，如contain */
    }
    .navlist1:hover {
      width: 372px;
      height: 406px;
      background-image: url("../../public/img/economy/pic_dkjj_cpys_card_pre.png");
      background-repeat: no-repeat;
      background-size: cover; /* 或者根据需要使用其他值，如contain */
    }

    .navlist1 {
      float: left;
      width: 372px;
      height: 406px;
      margin-top: 250px;
      margin-left: 220px;
      //background-image: url("../../public/img/economy/pic_dkjj_cpys_card_pre.png");
      background-image: url("../../public/img/economy/pic_dkjj_cpys_card_nors.png");

      background-repeat: no-repeat;
      background-size: cover; /* 或者根据需要使用其他值，如contain */
      background-position: center;
      background-clip: content-box;
      position: relative;

      .navlist1-1 {
        width: 80px;
        height: 80px;
        position: absolute;
        top: 55px;
        left: 50px;
      }
      .navlist1-2 {
        position: absolute;
        top: 155px;
        left: 52px;
        color: white;
        font-size: 24px;
        font-weight: 400;
      }
      .navlist1-3 {
        width: 260px;
        white-space: break-all;
        text-align: left;
        position: absolute;
        top: 205px;
        left: 50px;
        color: white;
        font-size: 14px;
        font-weight: 400;
      }
    }
    .navlist2 {
      float: left;
      width: 372px;
      height: 406px;
      margin-top: 230px;

      background-image: url("../../public/img/economy/pic_dkjj_cpys_card_nors.png");
      background-repeat: no-repeat;
      background-size: cover; /* 或者根据需要使用其他值，如contain */
      background-position: center;
      background-clip: content-box;
      position: relative;
      .navlist1-1 {
        width: 80px;
        height: 80px;
        position: absolute;
        top: 55px;
        left: 50px;
      }
      .navlist1-2 {
        position: absolute;
        top: 155px;
        left: 52px;
        color: white;
        font-size: 24px;
        font-weight: 400;
      }
      .navlist1-3 {
        width: 260px;
        white-space: break-all;
        text-align: left;
        position: absolute;
        top: 205px;
        left: 50px;
        color: rgba(255, 255, 255, 0.8);
        font-size: 14px;
        font-weight: 400;
      }
    }
    .navlist3 {
      float: left;
      width: 372px;
      height: 406px;
      margin-top: 250px;

      background-image: url("../../public/img/economy/pic_dkjj_cpys_card_nors.png");
      background-repeat: no-repeat;
      background-size: cover; /* 或者根据需要使用其他值，如contain */
      background-position: center;
      background-clip: content-box;
      position: relative;
      .navlist1-1 {
        width: 80px;
        height: 80px;
        position: absolute;
        top: 55px;
        left: 60px;
      }
      .navlist1-2 {
        position: absolute;
        top: 155px;
        left: 62px;
        color: white;
        font-size: 24px;
        font-weight: 400;
      }
      .navlist1-3 {
        width: 260px;
        white-space: break-all;
        text-align: left;
        position: absolute;
        top: 205px;
        left: 60px;
        color: rgba(255, 255, 255, 0.8);
        font-size: 14px;
        font-weight: 400;
      }
    }
    .navlist4 {
      float: left;
      width: 372px;
      height: 406px;
      margin-top: 230px;

      background-image: url("../../public/img/economy/pic_dkjj_cpys_card_nors.png");
      background-repeat: no-repeat;
      background-size: cover; /* 或者根据需要使用其他值，如contain */
      background-position: center;
      background-clip: content-box;
      position: relative;
      .navlist1-1 {
        width: 80px;
        height: 80px;
        position: absolute;
        top: 55px;
        left: 60px;
      }
      .navlist1-2 {
        position: absolute;
        top: 155px;
        left: 55px;
        color: white;
        font-size: 24px;
        font-weight: 400;
      }
      .navlist1-3 {
        width: 260px;
        white-space: break-all;
        text-align: left;
        position: absolute;
        top: 205px;
        left: 55px;
        color: rgba(255, 255, 255, 0.8);
        font-size: 14px;
        font-weight: 400;
      }
    }
    .navlist5 {
      float: left;
      width: 372px;
      height: 406px;
      // margin-top: 250px;
      margin-left: 220px;
      background-image: url("../../public/img/economy/pic_dkjj_cpys_card_nors.png");
      background-repeat: no-repeat;
      background-size: cover; /* 或者根据需要使用其他值，如contain */
      background-position: center;
      background-clip: content-box;
      position: relative;

      .navlist1-1 {
        width: 80px;
        height: 80px;
        position: absolute;
        top: 55px;
        left: 50px;
      }
      .navlist1-2 {
        position: absolute;
        top: 155px;
        left: 52px;
        color: white;
        font-size: 24px;
        font-weight: 400;
      }
      .navlist1-3 {
        width: 260px;
        white-space: break-all;
        text-align: left;
        position: absolute;
        top: 205px;
        left: 50px;
        color: white;
        font-size: 14px;
        font-weight: 400;
      }
    }
    .navlist6 {
      float: left;
      width: 372px;
      height: 406px;
      margin-top: -20px;
      // margin-left: 220px;
      background-image: url("../../public/img/economy/pic_dkjj_cpys_card_nors.png");
      background-repeat: no-repeat;
      background-size: cover; /* 或者根据需要使用其他值，如contain */
      background-position: center;
      background-clip: content-box;
      position: relative;

      .navlist1-1 {
        width: 80px;
        height: 80px;
        position: absolute;
        top: 55px;
        left: 50px;
      }
      .navlist1-2 {
        position: absolute;
        top: 155px;
        left: 52px;
        color: white;
        font-size: 24px;
        font-weight: 400;
      }
      .navlist1-3 {
        width: 260px;
        white-space: break-all;
        text-align: left;
        position: absolute;
        top: 205px;
        left: 50px;
        color: white;
        font-size: 14px;
        font-weight: 400;
      }
    }
    .navlist7 {
      float: left;
      width: 372px;
      height: 406px;
      // margin-top: 250px;
      // margin-left: 220px;
      background-image: url("../../public/img/economy/pic_dkjj_cpys_card_nors.png");
      background-repeat: no-repeat;
      background-size: cover; /* 或者根据需要使用其他值，如contain */
      background-position: center;
      background-clip: content-box;
      position: relative;

      .navlist1-1 {
        width: 80px;
        height: 80px;
        position: absolute;
        top: 55px;
        left: 50px;
      }
      .navlist1-2 {
        position: absolute;
        top: 155px;
        left: 52px;
        color: white;
        font-size: 24px;
        font-weight: 400;
      }
      .navlist1-3 {
        width: 260px;
        white-space: break-all;
        text-align: left;
        position: absolute;
        top: 205px;
        left: 50px;
        color: white;
        font-size: 14px;
        font-weight: 400;
      }
    }
    .navlist8 {
      float: left;
      width: 372px;
      height: 406px;
      margin-top: -20px;
      // margin-left: 220px;
      background-image: url("../../public/img/economy/pic_dkjj_cpys_card_nors.png");
      background-repeat: no-repeat;
      background-size: cover; /* 或者根据需要使用其他值，如contain */
      background-position: center;
      background-clip: content-box;
      position: relative;

      .navlist1-1 {
        width: 80px;
        height: 80px;
        position: absolute;
        top: 55px;
        left: 50px;
      }
      .navlist1-2 {
        position: absolute;
        top: 155px;
        left: 52px;
        color: white;
        font-size: 24px;
        font-weight: 400;
      }
      .navlist1-3 {
        width: 260px;
        white-space: break-all;
        text-align: left;
        position: absolute;
        top: 205px;
        left: 50px;
        color: white;
        font-size: 14px;
        font-weight: 400;
      }
    }
  }
  .titleproduct {
    font-size: 48px;
    font-weight: 600;
    color: white;
    position: absolute;
    left: 260px;
    top: 145px;
    font-family: "PingFang SC", "PingFang SC-400";
    .titleproduct1 {
      font-size: 48px;
      font-weight: 600;
      font-family: arial;
      background: linear-gradient(90deg, #ffffff, #dd915e, #f08b26);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      font-family: "PingFang SC", "PingFang SC-400";
    }
  }
  .product1 {
    z-index: 80;
    position: absolute;
    top: 0;
    left: 12.5%;
    // height: 9px;
    width: 70%;
    border-top: 90px solid white;

    border-left: 50px solid transparent;
    border-right: 50px solid transparent;
  }
  .product2 {
    position: absolute;
    bottom: 0;
    left: 12.5%;
    // height: 9px;
    width: 70%;
    // background-color: white;
    // border-bottom: 100px solid white;
    border-bottom: 90px solid white;
    border-left: 50px solid transparent;
    border-right: 50px solid transparent;
  }
}

.UAV {
  margin-top: 110px;
  width: 100%;
  height: 959px;
  background-image: url("../../public/img/economy/pic_dkjj_jscx_bg.png");
  background-repeat: no-repeat;
  background-size: cover;

  position: relative;
  .UAV1 {
    color: white;
    position: absolute;
    top: 170px;
    left: 260px;
    .title-e {
        opacity: 0.6;
        font-size: 12px;
        font-family: "PingFang SC", "PingFang SC-400";
        font-weight: 400;
        text-align: LEFT;
        color: #fff;
        margin-left: 3px;
      }
    .UAV1-1 {
      font-size: 48px;
      font-weight: 600;
      font-family: "PingFang SC", "PingFang SC-400";
    }
    .UAV1-2 {
      font-size: 48px;
      font-weight: 600;
      font-family: arial;
      background: linear-gradient(90deg, #ffffff, #dd915e, #f08b26);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      font-family: "PingFang SC", "PingFang SC-400";
    }
  }
  .UAV2 {
    padding-top: 16%;
    margin-left: 13%;
    .UAV2-1 {
      z-index: 10;
      margin-top: 24px;
      // width: 30%;
      width: 20%;
      height: 123px;
      float: left;
      margin-left: 1%;

      position: relative;
      background-image: url("../../public/img/economy/pic_dkjj_jscx_card.png");
      background-repeat: no-repeat;
      background-size: cover;

      .UAV2-1-1 {
        position: absolute;
        top: 30px;
        left: 20px;
      }
      .UAV2-1-2 {
        font-size: 16px;
        color: white;
        position: absolute;
        top: 50px;
        left: 100px;
      }
    }
  }
  .product3 {
    position: absolute;
    top: 0;
    left: 12.5%;
    // height: 9px;
    width: 70%;
    // background-color: white;
    // border-bottom: 100px solid white;
    border-top: 90px solid white;
    border-left: 50px solid transparent;
    border-right: 50px solid transparent;
  }
}
.FREE {
  width: 100%;
  height: 716px;
  position: relative;
  .frees {
    height: 78px;
    position: absolute;
    top: -9.8%;
    z-index: 10;
  }
  .frees1 {
    height: 78px;
    position: absolute;
    bottom: 9.8%;
    z-index: 10;
  }
  .FREE1 {
    width: 1920px;
    height: 560px;
    background-image: url("../../public/img/economy/Group543.png");
    background-repeat: no-repeat;
    background-size: cover;
    position: absolute;

    // top: -11%;
    .FREE1-1 {
      color: #ffffff;
      font-size: 48px;
      font-weight: 400;

      position: absolute;
      top: 100px;
      left: 250px;
      .FREE1-1-1 {
        height: 70px;
        margin-top: 10px;
        opacity: 0.4;
        font-size: 80px;
        text-align: LEFT;
        color: #ffffff;
      }
    }
    .FREE1-2 {
      position: absolute;
      top: 190px;
      right: 330px;
      .FREE1-2-1:nth-of-type(2) {
        padding-left: 20px;
      }
      .FREE1-2-1 {
        float: left;
        // border-radius: 1000px;
        position: relative;
        .fixed-text {
          position: absolute;
          left: 12px;
          top: 50%;
          transform: translateY(-50%);
          color: #ffffff;
          pointer-events: none; /* 确保不干扰输入 */
          font-size: 24px;
        }
        .FREE1-2-1-1::placeholder {
          color: #e6e0e0;
          padding-left: 30px;
          position: relative;
          width: 300px;
          margin: 20px auto;
        }
        .FREE1-2-1-1 {
          width: 258px;
          height: 66px;
          background: rgba(255, 255, 255, 0.3);
          // border: 0.1px solid;
          font-size: 24px;
          color: #e6e0e0;
          border-image: linear-gradient(180deg, rgba(255, 255, 255, 0) 100%) 1 1;
          border-radius: 8px;

          padding: 8px 12px 8px 70px; /* 左侧留出足够空间 */
          box-sizing: border-box;
        }
      }
      .FREE1-2-2 {
        .FREE1-2-1-1::placeholder {
          color: #e6e0e0;
          padding-left: 10px;
        }
        // position: relative;
        .fixed-text {
          position: absolute;
          left: 12px;
          top: 118px;
          transform: translateY(-50%);
          color: #ffffff;
          pointer-events: none; /* 确保不干扰输入 */
          font-size: 24px;
        }
        .FREE1-2-1-1 {
          margin-top: 20px;
          width: 540px;
          height: 66px;
          background: rgba(255, 255, 255, 0.3);
          border: 1px solid;
          font-size: 24px;
          color: #e6e0e0;

          border-image: linear-gradient(180deg, rgba(255, 255, 255, 0) 100%) 1 1;
          border-radius: 8px;
          padding: 8px 12px 8px 70px; /* 左侧留出足够空间 */
          box-sizing: border-box;
        }
        .FREE1-2-1-2 {
          // width: 700px;
          width: 540px;
          margin-top: 20px;
          font-family: PingFang SC, PingFang SC-400;
          font-weight: 400;
          font-size: 20px;
          // text-align: LEFT;
          color: #0063e6;
          height: 86px;
          background: #ffffff;
          border-radius: 8px;
          border: 1px solid white;
        }
      }
      .FREE1-2-2 {
        width: 100%;
      }
      .FREE1-2-3 {
        width: 100%;
      }
    }
  }
}
.sider {
  width: 100%;
  height: 624px;
  position: relative;
  // max-height: 624px;
  // overflow: hidden;
  // flex: 1;
  // height: auto; /* 或设置明确的高度 */
  margin-top: -157px;
  z-index: -1;
  .sider1 {
    width: 100%;
    height: 100%;
    background-image: url("../../public/img/economy/pic_dkjj_db_bg.png");
    background-size: cover;
    background-repeat: no-repeat;
    // position: absolute;
    // bottom: 156px;
    z-index: -10;
  }
  .sider2 {
    position: absolute;
    top: 200px;
    left: 260px;
    color: white;
    width: 1500px;
    .bor {
      position: relative;
      top: 100px;
      width: 1400px;
      border-bottom: 1px solid rgb(151, 145, 145);
    }

    .sider2-1 {
      width: 335px;
      height: 60px;
      float: left;
      .sider2-3 {
        text-align: left;
        line-height: 23px;
        .sider2-3-1 {
          font-size: 16px;
        }
        .sider2-3-2 {
          font-size: 14px;
          color: #aca3a3;
        }
      }
      .sider2-2 {
        float: left;

        .sider2-2-1 {
          width: 50px;
          height: 50px;
        }
      }
    }
    .sider2-1:nth-of-type(2) {
      margin-left: 50px;
    }
    .sider2-1:nth-of-type(3) {
      margin-left: 25px;
    }
    .sider2-1:nth-of-type(4) {
      margin-left: 25px;
    }
  }
  .sider3 {
    position: absolute;
    top: 380px;
    left: 260px;
    color: white;
    width: 1000px;
    .sider3-2 {
      // height: 300px;
      width: 55%;
      text-align: left;
      position: absolute;
      left: 800px;
      padding-left: 305px;
      .sider3-2-2 {
        width: 590px;
        height: 40px;
        font-size: 29px;
        font-family: Alibaba PuHuiTi, Alibaba PuHuiTi-700;
        font-weight: 700;
        text-align: LEFT;
        color: #ffffff;
        letter-spacing: 0.12px;
      }
      .sider3-2-4 {
        margin-top: 10px;
        width: 550px;
        height: 40px;
        font-size: 16px;
        font-family: Alibaba PuHuiTi, Alibaba PuHuiTi-700;
        font-weight: 700;
        text-align: LEFT;
        color: #ffffff;
        letter-spacing: 0.12px;
      }
      .sider3-2-1 {
        .sider3-2-1-2 {
          margin-left: 10px;
          width: 69px;
          height: 19px;
          opacity: 0.6;
          font-size: 14px;
          font-family: Alibaba PuHuiTi, Alibaba PuHuiTi-400;
          font-weight: 400;
          text-align: LEFT;
          color: #ffffff;
        }
      }
      .sider3-2-3 {
        margin-top: 10px;
        .sider3-2-3-2 {
          margin-left: 10px;
          width: 69px;
          height: 19px;
          opacity: 0.6;
          font-size: 14px;
          font-family: Alibaba PuHuiTi, Alibaba PuHuiTi-400;
          font-weight: 400;
          text-align: LEFT;
          color: #ffffff;
        }
      }
    }
    .sider3-1 {
      width: 45%;
      float: left;
      .sider3-1-1 {
        .sider3-1-1-2 {
          margin-left: 20px;
          height: 23px;
          font-size: 17px;
          font-family: OPlusSans 3, OPlusSans 3-400;
          font-weight: 400;
          text-align: LEFT;
          color: #e7dcdc;
          line-height: 22px;
        }
      }
      .sider3-1-2 {
        margin-top: 25px;
        width: 555px;
        .sider3-1-2-1 {
          height: 20px;
          opacity: 0.8;
          font-size: 14px;
          font-family: Helvetica, Helvetica-700;
          font-weight: 700;
          text-align: left;
          color: #ffffff;
        }
        .sider3-1-2-2 {
          height: 20px;
          opacity: 0.6;
          font-size: 14px;
          font-family: Helvetica, Helvetica-700;
          font-weight: 700;
          text-align: left;
          color: #ffffff;
        }
      }
      .sider3-1-3 {
        // width: 555px;
        text-align: left;
        margin-left: 4px;
        margin-top: 25px;
        .sider3-1-3-1 {
          width: 280px;
          height: 20px;
          opacity: 0.6;
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-400;
          font-weight: 400;
          text-align: left;
          color: #ffffff;
          a {
            color: #ffffff;
            text-decoration: none;
            cursor: pointer;
            transition: opacity 0.3s;
            &:hover {
              opacity: 1;
              text-decoration: underline;
            }
          }
        }
      }
    }
    .sider3-2 {
      width: 55%;
      float: left;
    }
  }
}
.navlist1-1-1 {
  width: 80px;
  height: 80px;
}
.UAV2-1-1-1 {
  width: 60px;
  height: 60px;
}
.helicopter1-1 {
  width: 266px;
  height: 135px;
}
.jichu1 {
  width: 100%;
  max-width: 1048px;
  height: auto;
}
.jichu2 {
  width: 1400px;
  height: 570px;
}
.icons {
  width: 42px;
  height: 42px;
}
.bans {
  position: absolute;
  top: 650px;
  left: 300px;
  z-index: 101;
  width: 200px;
  height: 60px;
}
.siderbaner {
  width: 115px;
  height: 26px;
}
.scene1 {
  height: 1700px;
}
.lunbotu {
  width: 450px;
  height: 470px;
}
.auvimg {
  width: 100%;
  max-width: 450px;
  height: auto;
}
.titleimg {
  width: 100%;
  max-width: 480px;
  height: auto;
}
.scene1 {
  position: relative;
  .product3 {
    position: absolute;
    top: 0;
    left: 13%;
    // height: 9px;
    width: 68%;
    // background-color: white;
    // border-bottom: 100px solid white;
    border-top: 90px solid white;
    border-left: 50px solid transparent;
    border-right: 50px solid transparent;
  }
}
.summing {
  position: relative;
}
.rigimgs{
  width: 79px;
  height: 60px;

}
.height1-outer {
  width: 100%;
  overflow: hidden;
  position: relative;
}
.scroll-tip {
  position: absolute;
  right: 8px;
  top: 40px;
  width: 6px;
  height: 40px;
  border-radius: 3px;
  background: rgba(200,200,200,0.5);
  transition: background 0.2s, height 0.2s;
  z-index: 20;
}
.scroll-tip.atBottom {
  background: #ff5a36;
  height: 60px;
}
.custom-scrollbar {
  position: absolute;
  // right: 200px;
  width: 6px;
  margin-right: 180px;
  background: #EBEBEB;
  border-radius: 4px;
  cursor: pointer;
  z-index: 20;
  opacity: 0.85;
  transition: background 0.2s, height 0.2s;
}
.custom-scrollbar:hover {
  background: linear-gradient(180deg, #ff0844 0%, #ffb199 100%);
  opacity: 1;
}
</style>

